
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/starfsfolk",
      function () {
        return require("private-next-pages/um/fyrirtaekid/starfsfolk.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/starfsfolk"])
      });
    }
  